export const setFulfillableOrdersFilters = (filters) => {
    return {
        type: "SET_FULFILLABLE_ORDERS_FILTERS",
        payload: filters
    }
};
